// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { LMspecialHours, ListingSpecialHoursData } from './types';

export interface ActionGetLMSpecialHoursAPI extends Action {
  listingId: string
}

export const getLMSpecialHoursAPI = (listingId: string): ActionGetLMSpecialHoursAPI => ({
  type: ACTIONS.GET_LMSPECIALHOURS_API_REQUEST,
  listingId,
});

export interface ActionGetLMSpecialHoursAPISuccess extends Action {
  lmspecialHours: LMspecialHours
}

export const getLMSpecialHoursAPISuccess = (lmspecialHours: LMspecialHours): ActionGetLMSpecialHoursAPISuccess => ({
  type: ACTIONS.GET_LMSPECIALHOURS_API_SUCCESS,
  lmspecialHours
});

export const getLMSpecialHoursAPIError = (): Action => ({
  type: ACTIONS.GET_LMSPECIALHOURS_API_ERROR,
});


export interface ActionPostLMSpecialHoursAPI extends Action {
  listingId: string;
  specialHoursData: ListingSpecialHoursData;
}

export const postLMSpecialHoursAPI = (listingId: string, specialHoursData: ListingSpecialHoursData): ActionPostLMSpecialHoursAPI => ({
  type: ACTIONS.POST_LMSPECIALHOURS_API_REQUEST,
  listingId,
  specialHoursData,
});

export interface ActionPostLMSpecialHoursAPISuccess extends Action {
  lmspecialHours: LMspecialHours
}

export const postLMSpecialHoursAPISuccess = (lmspecialHours: LMspecialHours): ActionPostLMSpecialHoursAPISuccess => ({
  type: ACTIONS.POST_LMSPECIALHOURS_API_SUCCESS,
  lmspecialHours
});

export const postLMSpecialHoursAPIError = (): Action => ({
  type: ACTIONS.POST_LMSPECIALHOURS_API_ERROR,
});